<template>
  <div
    id="app"
    class="tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-black"
  >
    <div
      v-if="!landscape"
      class="tw-fixed tw-w-screen tw-h-full tw-top-0 tw-left-0 tw-bg-white tw-bg-opacity-70 tw-flex tw-justify-center tw-items-center tw-z-50 tw-flex-col"
    >
      <img class="tw-w-2/5" :src="imgPath + '/landscape.png'" />
      <span
        class="tw-text-black tw-text-6xl tw-text-center tw-max-w-8xl tw-mt-4"
        >The webpage under the portrait mode will not be supported,<br />please
        rotate your device to landscape mode.</span
      >
    </div>
    <div class="fullpage-container fullpage" v-if="!mobile">
      <div class="fullpage-wp" v-fullpage="opts" ref="example">
        <div class="page-1 page">
          <top-section :mobile="mobile" :wWidth="wWidth" />
        </div>
        <div class="page-2 page" v-if="!mobile">
          <nav-section :moveToSlide="moveToSlide" />
        </div>
        <div class="page-3 page">
          <scenario-section :mobile="mobile" />
        </div>
        <div class="page-4 page">
          <map-section :mobile="mobile" />
        </div>
        <div class="page-5 page">
          <boss-section :mobile="mobile" />
        </div>
        <div class="page-6 page">
          <monster-section :mobile="mobile" />
        </div>
        <div class="page-7 page">
          <npc-section :mobile="mobile" />
        </div>
      </div>
      <div
        class="tw-absolute tw-bottom tw-right-0.25/10 2xl:tw-bottom-56 xl:tw-bottom-14 tw-cursor-pointer tw-w-32 tw-h-32  tw-bg-contain tw-bg-top-btn hover:tw-bg-btn-hover focus:tw-bg-btn-hover"
        v-if="topBtn"
        @click="moveToTop"
      ></div>
    </div>
    <div class="tw-w-full tw-h-full" v-if="mobile">
      <section class="tw-snap-start">
        <top-section :mobile="mobile" />
      </section>
      <div class="tw-snap-start">
        <scenario-section :mobile="mobile" />
      </div>
      <section class="tw-snap-start">
        <map-section :mobile="mobile" />
      </section>
      <section class="tw-snap-start">
        <boss-section :mobile="mobile" />
      </section>
      <section class="tw-snap-start">
        <monster-section :mobile="mobile" />
      </section>
      <section class="tw-snap-start">
        <npc-section :mobile="mobile" />
      </section>
      <section class="tw-snap-start">
        <bottom-section />
      </section>
    </div>
  </div>
</template>

<script>
import TopSection from "./views/TopSection.vue";
import NavSection from "./views/NavSection.vue";
import ScenarioSection from "./views/ScenarioSection.vue";
import MapSection from "./views/MapSection.vue";
import BossSection from "./views/BossSection.vue";
import MonsterSection from "./views/monsterSection.vue";
import NpcSection from "./views/NpcSection.vue";
import BottomSection from "./views/BottomSection.vue";

export default {
  name: "App",
  components: {
    TopSection,
    NavSection,
    ScenarioSection,
    MapSection,
    BossSection,
    MonsterSection,
    NpcSection,
    BottomSection
  },
  data() {
    var that = this;
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      bottomActive: false,
      topBtn: false,
      currentIndex: 0,
      wWidth: window.innerWidth,
      mobile: false,
      landscape: true,
      opts: {
        start: 0,
        dir: "v",
        der: 0.08,
        duration: 200,
        disabled: false,
        beforeChange: function(currentSlideEl, currenIndex, nextIndex) {
          console.log("before", currenIndex);
          if (nextIndex >= 1) {
            that.topBtn = true;
          } else if (nextIndex === 0) {
            that.topBtn = false;
          }
          if (currenIndex === 6) {
            that.bottomActive = false;
          }
        },
        afterChange: function(currentSlideEl, currenIndex) {
          console.log("after", currenIndex);
          if (currenIndex === 6) {
            that.bottomActive = true;
            that.currentIndex = currenIndex;
            //console.log("global after", that.currentIndex);
          }
        }
      }
    };
  },
  methods: {
    moveToSlide: function(index) {
      console.log(this.$refs.example.$fullpage, index);
      let page = index;
      if (index === 3) {
        page = index + 3;
      } else {
        page = index + 2;
      }
      this.$refs.example.$fullpage.moveTo(page, true, false);
    },
    moveToTop: function() {
      this.$refs.example.$fullpage.moveTo(0, true, false);
    },
    handleWidthOrientation: function(e) {
      const orientation = window.screen.orientation.type;
      this.wWidth = window.innerWidth;

      if (this.wWidth <= 640) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
      if (this.wWidth <= 1366 && orientation === "landscape-primary") {
        console.log("landscape");
        this.landscape = true;
      }
      if (this.wWidth <= 1024 && orientation === "portrait-primary") {
        console.log("portrait");
        this.landscape = false;
      }
      if (this.wWidth <= 540 && orientation === "portrait-primary") {
        this.landscape = true;
      }

      console.log(
        `orientation:${orientation}, width:${this.wWidth}, mobile:${this.mobile}, landscape:${this.landscape}`
      );
    }
  },
  mounted: function() {
    window.onresize = () => {
      this.wWidth = window.innerWidth;
    };
    if (this.wWidth <= 640) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    //console.log("mount window width", this.wWidth, this.mobile);
  },
  created: function() {
    window.addEventListener("load", this.handleWidthOrientation);
    //console.log("created window width", this.wWidth, this.mobile);
    window.addEventListener("resize", this.handleWidthOrientation);
    window.addEventListener("orientationchange", this.handleWidthOrientation);
  },
  destroyed: function() {
    window.removeEventListener("load", this.handleWidthOrientation);
    window.removeEventListener("resize", this.handleWidthOrientation);
    window.removeEventListener(
      "orientationchange",
      this.handleWidthOrientation
    );
  }
};
</script>

<style lang="postcss" scoped>
.fullpage {
  @apply tw-h-screen tw-max-w-192;
}
.changepage {
  @apply tw-h-72 tw-w-full;
}
</style>
